import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TStatusRowProps = {
  icon: ReactNode;
  children: ReactNode;
  muted?: boolean;
  className?: string;
};

export function StatusRow({ icon, children, muted = false, className }: TStatusRowProps) {
  return (
    <div className={cn("flex w-full items-start gap-[8px]", className)}>
      <span
        className={cn(
          "flex shrink-0 items-center pt-[3px]",
          muted ? "text-innoveraZinc-500" : "text-innoveraZinc-900"
        )}
      >
        {icon}
      </span>
      <p
        className={cn(
          "min-w-0 flex-1 text-[14px] leading-[22px]",
          muted ? "text-innoveraZinc-500" : "text-innoveraZinc-900"
        )}
      >
        {children}
      </p>
    </div>
  );
}
